<template>
  <div>
    <b-modal
      size="sm"
      no-close-on-backdrop
      hide-header-close
      hide-footer
      centered
      :id="`separate-warning-${check_time}`"
      title="ATENÇÃO"
    >
      <div class="row">
        <div class="col-md-12 text-center pt-0 pb-0">
          <p class="worksansr">
            O(s) medicamento(s) abaixo não está(ão) disponível(is) no estoque
            <strong>{{ stock.name ? stock.name : "PRINCIPAL" }}</strong
            >. O(s) mesmo(s) será(ão) desmarcado(s) para separação.
          </p>
        </div>
        <div class="col-md-12 pt-0">
          <p
            class="m-0 border-bottom"
            v-for="(item, key) in invalidMedications"
            :key="key"
          >
            {{ item.name }}
          </p>
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <v-btn @click="handleCloseModalWarning" class="v-warning btn-block"
            >ENTENDI</v-btn
          >
        </div>
      </div>
    </b-modal>
    <!-- AQUI -->
    <v-btn
      :disabled="
        medicines_check.length == 0 || time != check_time || countSeparated > 0
      "
      class="btn-modern btn-modern-info mr-2"
      @click="handleOpenModal"
    >
      <i class="fas fa-check-square mr-2 text-twenty"></i>
      SEPARAR SELECIONADOS
    </v-btn>
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      :id="`modalSeparateSelected_${check_time}`"
      title="SEPARAR"
    >
      <b-overlay :show="loadingVerify" opacity="0.99">
        <div class="row">
          <div
            v-if="!checked && !other_stock && stock_group.length > 0"
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pb-0"
          >
            <label>ESTOQUE QUE VAI DAR BAIXA</label>
            <select v-model="stock_id" class="form-control">
              <option value>SELECIONE...</option>
              <option
                v-for="item in stock_group"
                :key="item.id"
                :value="item.id"
              >
                {{ item.stock_owner }}
              </option>
            </select>
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="notdiv-realized">
              <b-form-checkbox
                @input="stock_id = ''"
                id="checked"
                v-model="checked"
                name="checked"
                >MARCAR COMO NÃO REALIZADO?</b-form-checkbox
              >
            </div>
          </div>
          <div
            v-if="checked"
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          >
            MOTIVO DA NÃO REALIZAÇÃO
            <ChromeSpeechToTextTextarea rows="4" max-rows="10" v-model="note" />
          </div>
          <div
            v-if="false"
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
          >
            JUSTIFICATIVA DA CHECAGEM COM ATRASO
            <ChromeSpeechToTextTextarea
              rows="4"
              max-rows="10"
              v-model="justification"
            />
          </div>
          <div class="col-md-12">
            <ErrorsMessages :errors="errors" />
          </div>
          <div class="col-md-12 text-right">
            <v-btn
              :disabled="(loading || !hasInStock) && !checked"
              @click="handleToSeparate"
              :class="['btn-modern',!checked && 'btn-modern-save', checked && 'btn-notcertified']"
            >
              <i class="fas fa-check mr-2 text-twenty"></i>
              <span v-if="!checked">{{
                loading ? "CARREGANDO" : "AVANÇAR"
              }}</span>
              <span v-if="checked">
                {{
                  loading
                    ? "CARREGANDO"
                    : "FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA"
                }}
              </span>
            </v-btn>
          </div>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages";

import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import routes from "../../../../routes";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import { userData } from "../../../../lib/functions";

import { formatDateOnlyNumbers, numbersOnly } from "../../../../lib/format";

export default {
  name: "Separate",
  components: {
    ErrorsMessages,
    ChromeSpeechToTextTextarea,
  },
  props: {
    date: [String, Number],
    check_time: [String, Number],
    time: [String, Number],
    medicines_check: Array,
  },
  data() {
    return {
      resident_id: "",
      rest_home_id: "",
      stock_id: "",
      stock_group: [],
      enough_stocks: [],
      stocksByMedicine: [],
      invalidMedications: [],
      stocksResidentByMedicine: [],
      stock: {},
      note: "",
      justification: "",
      show_justification: false,
      checked: false,
      loading: false,
      loadingVerify: false,
      other_stock: false,
      hasInStock: false,
      countSeparated: 0,
      errors: [],
    };
  },
  watch: {
    medicines_check: function () {
      this.retrieve();
    },
  },
  created() {
    this.retrieve();
  },
  methods: {
    numbersOnly,
    formatDateOnlyNumbers,
    handleCloseModalWarning() {
      this.$bvModal.hide(`separate-warning-${this.check_time}`);
      this.$bvModal.hide(`modalSeparateSelected_${this.check_time}`);
      this.$emit("remove-separate-warning", this.invalidMedications);
    },
    async handleOpenModal() {
      this.$bvModal.show(`modalSeparateSelected_${this.check_time}`);
      this.note = "";
      this.justification = "";
      this.checked = false;
      this.errors = [];
      this.other_stock = false;

      await this.getStocksByMedicine();
    },
    handleToSeparate() {
      let { checked, note } = this;

      if (checked) {
        if (!note || !String(note).trim()) {
          this.errors = [{ id: 1, message: "Informe a observação" }];
          return;
        }
      }

      this.separate();
    },
    async retrieve() {
      this.errors = [];
      this.countSeparated = 0;
      this.show_justification = false;

      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;

      const { id } = routes.history.current.params;

      this.resident_id = id;

      let { time, medicines_check, date } = this;

      for (let item of medicines_check) {
        if (
          numbersOnly(item.prescription_medicine_time.time) == numbersOnly(time)
        ) {
          if (item.medicine_check.status == "SEPARADO") {
            this.countSeparated = this.countSeparated + 1;
          }
        }
      }

      if (
        parseInt(formatDateOnlyNumbers(date)) <
        parseInt(formatDateOnlyNumbers(new Date()))
      ) {
        this.show_justification = true;
      }
    },
    async getStocksByMedicine() {
      try {
        const { resident_id, medicines_check } = this;

        let medicines = [];
        for (let medicine of medicines_check) {
          medicines.push({
            id: medicine.prescription_medicine.medicine_id,
            quantity: medicine.prescription_medicine_time.quantity,
            prescription_medicine_time_id:
              medicine.prescription_medicine_time.id,
          });
        }

        let params = { resident_id, medicines };

        const response = await api.post(
          "/rest-home/resident/medicine-check/stock-by-medicines",
          params
        );

        const { error, errors, stock, stock_group, invalidMedications } =
          response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];

          this.stock = stock;
          this.invalidMedications = invalidMedications;

          if (invalidMedications.length > 0) {
            this.$bvModal.show(`separate-warning-${this.check_time}`);
          }

          if (stock_group.length > 0) {
            this.stock_id = stock_group[0].id;
            this.hasInStock = true;
          }

          this.stock_group = stock_group;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async separate() {
      try {
        this.loading = true;

        // if (this.show_justification) {
        //   if (!this.justification || !String(this.justification).trim()) {
        //     this.errors = [
        //       { id: this.errors, message: "Informe a justificativa" },
        //     ];
        //     this.loading = false;
        //     return;
        //   }
        // }

        let {
          stock_id,
          checked,
          note,
          medicines_check: prescription_medicine_time_ids,
          date,
          justification,
          resident_id,
        } = this;

        let params = {
          stock_id,
          checked,
          note,
          prescription_medicine_time_ids,
          date,
          justification,
          resident_id,
        };

        const response = await api.post(
          "/rest-home/check/separate-multiple",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(`modalSeparateSelected_${this.check_time}`);
          toast(message, "success");
          this.$emit("success");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
